export const AddCsvExtraLeadExpenseTableHeader = ({ pageType }) => [
  {
    field: 'user_cost_id',
    headerName: 'ID',
    width: 100,
  },
  {
    field: 'ogaName',
    headerName: 'Name',
    width: 200,
  },
  {
    field: pageType === 'bonus' ? 'bonus' : 'salary',
    headerName: pageType === 'bonus' ? 'Bonus' : 'Salary',
    width: 150,
  },
  { field: 'action', headerName: 'Action', type: 'action', actionType: 'edit', width: 150, actionKey: 'edit' },
];
